module.exports = __webpack_public_path__ + "static/media/coffee_desktop_fr.5708d6cc.jpg";